<template>
  <div class="bg">
    <div class="login-panel">
      <span class="title">欢迎登陆八爪鱼客户管理系统</span>
      <form v-if="!showForget" @submit.prevent="login">
        <input v-model="username" type="text" class="input mb-3" placeholder="请输入用户名" name="username">
        <input v-model="pass" type="password" class="input mb-3" placeholder="请输入密码" name="password">
        <div ref="vaptcha" style="width: 100%;height: 36px;margin-bottom: 10px;">
          <div class="vaptcha-init-main">
            <div class="vaptcha-init-loading">
              <a href="/" target="_blank">
                <img src="https://r.vaptcha.com/public/img/vaptcha-loading.gif" />
              </a>
              <span class="vaptcha-text">Vaptcha启动中...</span>
            </div>
          </div>
        </div>
        <button block class="info mb-3" type="submit">登录</button>
      </form>
      <button outline @click="btnForgetClicked">{{ btnForgetText }}</button>
    </div>
  </div>
</template>

<script>
  import axios from "../axios";
  import {mapActions} from 'vuex';

  export default {
    name: "Login",
    data() {
      return {
        username: "",
        pass: "",
        showForget: false,//显示忘记密码
        btnForgetText: '忘记密码',
        vaptchaObj: null
      };
    },

    methods: {
      ...mapActions(['setError']),
      btnForgetClicked() {
        this.$router.push({
          name: 'forgot-password'
        });
      },
      login(event) {
        let response = this.vaptchaObj.getToken();
        if (response && response !== '') {
          axios
            .post("/token", {
              grantType: "password",
              username: this.username,
              password: this.pass
            }, {
              headers: {
                'g-recaptcha-response': response
              }
            })
            .then(response => {
              localStorage.setItem("accessToken", response.data.accessToken);
              localStorage.setItem("refreshToken", response.data.refreshToken);
              this.setError('');

              this.$router.replace({
                name:localStorage.getItem('fromPath') || 'home'
              });
              localStorage.removeItem('fromPath');
            })
            .catch((reason) => {
              this.setError(reason.response.data.message);
              this.vaptchaObj.reset();
            });
        } else {
          this.setError('验证有误');
        }

      },
      renderGrecaptcha() {
        window.vaptcha({
          vid: '5df151acca7dd34ba15499d6',
          type: 'click',
          scene: '1',
          container: this.$refs.vaptcha,
          offline_server: process.env.VUE_APP_API + 'vaptcha/offline'
        }).then(obj => {
          obj.render();
          this.vaptchaObj = obj;
        });
      }
    },
    mounted() {
      if (this.$route.params.message != null) {
        this.setError(this.$route.params.message);
      }
      this.renderGrecaptcha();
    }
  };
</script>

<style scoped>
  .bg {
    /*background: url('../assets/bg.png') center center;*/
    background-size: cover;
    width: 100%;
    height: 100vh;
  }

  .login-panel {
    width: 88%;
    height: 402px;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    position: absolute;
    top: 50%;
    margin-top: -201px;
    left: 50%;
    padding: 30px 20px;
    margin-left: -44%;
  }

  .title {
    font-weight: 400;
    color: rgba(32, 133, 245, 1);
    line-height: 30px;
    margin-bottom: 32px;
    text-align: justify;
    text-justify: distribute-all-lines; /*ie6-8*/
    text-align-last: justify; /* ie9*/
    -moz-text-align-last: justify; /*ff*/
    -webkit-text-align-last: justify; /*chrome 20+*/
    width: 100%;
    display: block;
  }

  .vaptcha-init-main {
    display: table;
    width: 100%;
    height: 100%;
    background-color: #EEEEEE;
  }

  .vaptcha-init-loading {
    display: table-cell;
    vertical-align: middle;
    text-align: center
  }

  .vaptcha-init-loading>a {
    display: inline-block;
    width: 18px;
    height: 18px;
    border: none;
  }

  .vaptcha-init-loading>a img {
    vertical-align: middle
  }

  .vaptcha-init-loading .vaptcha-text {
    font-family: sans-serif;
    font-size: 12px;
    color: #CCCCCC;
    vertical-align: middle
  }
</style>
